import React, { Component, Fragment } from 'react';
import { withMixpanel } from '../context/mixPanelContext';
import { isEmpty, get } from 'lodash';

import {
  Container,
  Grid,
  Typography,
  Box,
  Divider,
} from '@material-ui/core';

import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';

import {
  getProductName,
  getDateTime,
  formatCurrency,
} from '../utils'

import Logo from '../components/Logo';
import { commonStyles } from '../styles';
import { getTextById } from '../components/Faqs/faqs_text';
import FeatureFlip from '../components/FeatureFlip'

const styles = theme => ({
  ...commonStyles(theme),
  divider: {
    margin: theme.spacing(3, 0)
  },
  button: {
    width: '302px',
    height: '64px',
    textTransform: 'capitalize',
    fontSize: '20px',
    borderColor: theme.palette.text.secondary,
    color: theme.palette.text.secondary,
    borderWidth: '2px',
    marginTop: '12px',
  },
  emailText: {
    color: '#434343',
    fontWeight: 'bold',
  },
  marginBottom: {
    marginBottom: '5rem',
  },
});

class Confirmation extends Component {
  componentDidMount() {
    this.trackConfirmationShow()
    window.sessionStorage.clear();
  }

  trackConfirmationShow = () => {
    const { mixpanel, quote, order, service } = this.props;
    if(isEmpty(quote)) return;
    const { partner_order_id } = order;
    const { product_sku } = service;
    const { service_name} = quote;
    const booking_id = get(order, 'products[0].booking_id', 'order');
    const order_product_id = get(order, 'products[0].order_product_id', 'order');
    mixpanel.tracker('confirmation_shown',{
      booking_id,
      order_product_id,
      partner_order_id,
      service_name,
      product_sku,
      product_type:'consumer'
    });
  }

  render() {
    const { service, quote, systemType, classes, width } = this.props;
    const { product_sku, date, time } = service;
    const { currency, full_price } = quote;

    return (
      <Container className={`${classes.container} ${classes.marginBottom}`}>
        <Grid container justify="center">
          <Grid item xs={12} sm={10} md={12}>
            <div className={classes.header}>
              <Logo />
              <Typography variant="h1" gutterBottom>Booking confirmed!</Typography>
            </div>
            <div className={classes.form}>
              {isWidthUp('sm', width)
              ? <Fragment>
                  <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1" color="textSecondary">HVAC Checkup Visit</Typography>
                    </Box>
                    <Box>
                      <FeatureFlip
                        feature='coSchedulingEnabled'
                        on={<Typography variant="subtitle1">Preferred date and time: {getDateTime(date, time)}</Typography>}
                        off={<Typography variant="subtitle1">{getDateTime(date, time)}</Typography>}
                      />
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                      <FeatureFlip
                        feature='coSchedulingEnabled'
                        on={null}
                        off={<Typography variant="subtitle1">{getProductName(product_sku, systemType)}</Typography>}
                      />
                    </Box>
                    { currency && full_price &&
                      <Box>
                        <Typography variant="subtitle1">{formatCurrency(currency.symbol, full_price)}</Typography>
                      </Box>
                    }
                  </Box>
                </Fragment>
              : <Fragment>
                  <Typography variant="subtitle1" color="textSecondary" gutterBottom>HVAC Checkup Visit</Typography>
                  <FeatureFlip
                    feature='coSchedulingEnabled'
                    on={null}
                    off={<Typography variant="subtitle1">{getProductName(product_sku, systemType)}</Typography>}
                  />
                  <Box display="flex" alignItems="center" pt={2}>
                    <Box flexGrow={1}>
                      <FeatureFlip
                        feature='coSchedulingEnabled'
                        on={<div>Preferred date and time: {getDateTime(date, time)}</div>}
                        off={<div>{getDateTime(date, time)}</div>}
                      />
                    </Box>
                    <Box>
                      {formatCurrency(currency.symbol, full_price)}
                    </Box>
                  </Box>
                </Fragment>
              }
              <Divider className={classes.divider} />
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" className={classes.emailText} >
                    What&apos;s Next?
                  </Typography>
                  <Typography variant="subtitle1" component='span'>
                    <p>You will receive an email shortly with your booking details and a link to manage, edit or cancel your booking.</p>
                  </Typography>
                  <FeatureFlip
                    feature='coSchedulingEnabled'
                    on={
                      <div>
                        <Typography variant="subtitle1" component='span'>
                          <p>Please make sure that you are available on your preferred date and time.</p>
                        </Typography>
                        <Typography variant="subtitle1" component='span'>
                          <p>Your assigned HVAC professional may reach out to to confirm the appointment and reschedule if necessary.</p>
                        </Typography>
                      </div>
                    }
                    off={null}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1" className={classes.emailText} >
                    What&apos;s Included?
                  </Typography>
                  <Typography variant="subtitle1" component='span' color="textSecondary">
                    { getTextById('included').a() }
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withStyles(styles)(withWidth()(withMixpanel(Confirmation)));
